import React from "react";
import PropTypes from "prop-types";
import { CheckboxField } from "cxa-form-field";
import { validateRequired } from "../validation";

const Declaration = ({ isReadOnly }) => (
  <div className="declaration">
    <h3>Declarations</h3>
    <p>
      {[
        "1) I hereby declare and confirm that I have read and understood the contents of ",
        '"Your Guide to Health Insurance" (applicable only to accident and health business), ',
        '"Your Guide to Life Insurance" and "Product Summary". (Applicable if coverage is on voluntary basis).',
      ].join("")}
    </p>
    <p>2) I/We hereby authorise, agree and consent to:</p>
    <p>
      (a) persons and organisations, whether within or outside Singapore, including but not limited
      to medical sources, hospitals, doctors, other healthcare professionals, laboratories,
      regulator, dispute resolution centres and insurers, their associated persons/organisations,
      my/our or the insured person’s employers or financial service providers, or their third party
      service providers or representatives (collectively “<strong>Third Parties</strong>
      ”) disclosing and releasing to AIA Singapore Private Limited ("
      <strong>AIA Singapore</strong>
      "), its associated persons/organisations, its and their third party service providers and its
      and their representatives, whether within or outside Singapore (collectively “
      <strong>AIA Persons</strong>
      ”), any information concerning the policy owner and the insured person(s) at any time,
      including all personal data and information, medical information, medical history,
      consultation history and notes, prescriptions, treatments, descriptions of medical services
      rendered, and any employment and financial information, including the taking of copies of such
      records (collectively “<strong>Personal Data</strong>
      ”), relevant for the Purpose (defined below);
    </p>
    <p>
      (b) the AIA Persons sharing the scope of sub-clause (a) above, along with any of the Personal
      Data, with any relevant Third Parties to procure their disclosure and release of additional
      relevant Personal Data for the Purpose;
    </p>
    <p>
      (c) the AIA Persons, including their approved medical examiners or laboratories, performing
      any necessary medical assessments and examinations and tests to determine, assess and evaluate
      the health of the insured person(s);
    </p>
    <p>
      (d) the AIA Persons collecting, using, disclosing, storing, retaining and/or processing
      (collectively, “<strong>Using”/“Use</strong>
      ”) the Personal Data for the Purpose; and
    </p>
    <p>
      (e) waive any right (on my own behalf and on behalf of the insured person(s) where applicable,
      in respect of which I/we represent and warrant that the insured person(s) have granted me/us
      authority to so waive) to bring a claim of any nature against any of the AIA Persons in
      respect of any above-mentioned Use and/or any Use of any Personal Data for the Purpose.
    </p>
    <p>
      Where I/we are not the insured person, I/we represent and warrant that I/we have obtained the
      consent of the insured person(s), except to the extent such consent is not required under
      relevant laws: (i) to collect their Personal Data; (ii) to disclose their Personal Data to the
      AIA Persons; and (iii) for the AIA Persons and Third Parties to Use any of their Personal Data
      in the manner and for the purposes described in this Clause. I/We hereby agree to indemnify
      AIA Persons for all losses and damages that AIA Persons may suffer in the event that I/we are
      in breach of any representation and warranty provided by me/us herein. In this Clause,
      “Purpose” means any of the purposes described in the AIA Personal Data Policy, including but
      not limited to processing of this form, to provide subsequent advice or services to me/us or
      the insured person in relation to any existing or future policy/policies/ programmes that I/we
      may hold/participate with AIA Singapore. This authorisation shall bind my/our successors and
      assignees, and remains valid, notwithstanding death, irrespective of whether or not my/our
      Application/form is accepted by AIA Singapore. A photocopy of this authorisation shall be
      valid and effective as the original.
    </p>
    <p>
      3) I understand and agree that AIA Singapore is entitled not to accept or process this form
      should I or any of my dependents be found to be a Prohibited Person, meaning a person/entity
      subject to any laws, regulations and/or sanctions administered by any regulatory authorities
      in any country , which have the effect of prohibiting AIA Singapore from providing insurance
      coverage, transacting business with or otherwise offering any economic benefits to me/my
      dependents or any other beneficiary under the Policy , and the decision of AIA Singapore shall
      be final. I/We further agree that in the event that AIA becomes aware subsequently that the
      Policyholder/myself/any of my dependents has become a Prohibited Person , AIA Singapore may
      block and/or terminate the Policy with immediate effect, remove myself or my dependents from
      coverage under the Policy and shall not thereafter be required to transact any business with
      the Policyholder and/or myself/my dependents in connection with the Policy, including but not
      limited to, making or receiving any payments under the Policy.
    </p>
    <p>
      4) I/We further agree that this form may be signed and delivered by facsimile, electronic mail
      or other electronic means, including via a website or electronic portal designated by AIA
      Singapore. A copy of such form received via any of the above means may be stored
      electronically or using other means by or under the authority of AIA Singapore and such copy
      shall have the same legal effect and validity as if it were the original.
    </p>
    <br />
    <p>
      {
        <CheckboxField
          {...(isReadOnly ? { disabled: { isReadOnly }, checked: { isReadOnly } } : {})}
          validate={validateRequired}
          name="declaration"
          id="declaration"
        >
          <strong>I have read and accept this declaration</strong>
        </CheckboxField>
      }
    </p>
  </div>
);

Declaration.propTypes = {
  isReadOnly: PropTypes.bool,
};

Declaration.defaultProps = {
  isReadOnly: false,
};

export default Declaration;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201706_NOCHILD/Declaration.js